import UltMeta, { Meta } from "./UltMeta/index";

export class QuickAccess extends UltMeta {
    // 进销存角色
    CONTRACT = new Meta(1, "新增采购订单");

    PAYMENT = new Meta(2, "新增销售结算");

    FREIGHT = new Meta(3, "新增进销存入库");

    SIGNATURE = new Meta(4, "新增进销存出库");

    RECONCILIATION = new Meta(5, "新增仓储业务盘点");

    INVOICE = new Meta(6, "新增仓储业务抽检");

    FINANCING = new Meta(7, "仓储业务库存查询");

    INVENTORY = new Meta(8, "仓储业务库存明细");

    OUTBOUND = new Meta(9, "新增仓储管理入库");

    SAMPLING = new Meta(10, "新增仓储管理出库");

    SHIPMENT = new Meta(11, "仓储管理库存查询");

    INBOUND = new Meta(12, "仓储管理库存明细");
}
export const QUICK_ACCESS = new QuickAccess();
